<template>
  <div class="page">
    <div class="app-header">
      <img src="../assets/img/tablogin.png" class="app-left" />
      <div class="app-center">网上营业厅</div>
      <div class="app-right">
        <el-dropdown trigger="click">
          <div class="dropdown">
            <div class="userInfo" v-if="userInfo.name">
              <img :src="userInfo.img" />
              <div class="name">{{ userInfo.name }}</div>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="loginout()"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="app-banner">
      <img src="../assets/img/banner.jpg" />
    </div>
  </div>
</template>

<script>
import { LoginOut } from "@/api/login";
// import { GetUserInfo } from "@/api/public";
export default {
  data() {
    return {
      userInfo: {
        name: "",
        img: "",
      },
    };
  },
  created() {
    if (this.$route.path != "/login") {
      this.getUserInfo();
    }
  },
  methods: {
    //获取用户信息
    getUserInfo() {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (userInfo == "" || userInfo == null) {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userInfo");
        this.$router.replace("/login");
      } else {
        this.userInfo.name = userInfo.name;
        this.userInfo.img = userInfo.img;
      }
    },
    //退出登录
    loginout() {
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          LoginOut()
            .then((res) => {
              window.sessionStorage.removeItem("token");
              window.sessionStorage.removeItem("userInfo");
              this.$router.push("/login");
              this.$message({
                type: "success",
                message: "退出成功",
                duration: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  .app-header {
    margin: 0 auto;
    padding: 20px 10px;
    width: 1400px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .app-left {
      width: 193px;
    }
    .app-center {
      font-size: 30px;
      color: #183883;
    }
    .app-right {
      text-align: center;
      width: 193px;
      .dropdown {
        cursor: pointer;
      }
      .userInfo {
        display: flex;
        align-items: center;
        img {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .name {
          font-size: 16px;
        }
      }
    }
  }
  .app-banner {
    width: 100%;
    background-color: #f5f7fa;
    img {
      width: 100%;
    }
  }
}
</style>